<template lang="pug">
  v-card.pa-3( flat color="blue-grey lighten-5" )
    div.headline Order Details
    v-layout(row wrap)
      v-flex.my-1(xs12)
        
        v-layout(row)
          v-flex(xs5 sm3)
            v-img.mx-2(:src="imageSrc" max-width="100")
          v-flex(xs7)
            div Delivering to:
            span.title {{event.eventName}}
      v-flex.my-1(xs12 sm6)
        strong Name:  
        span {{$store.state.customer.name}}
      v-flex.my-1(xs12 sm6)
        strong Email:  
        span {{$store.state.customer.email}}
      v-flex.my-1(xs12 sm6)
        strong Phone:  
        span {{$store.state.customer.phone}}
      v-flex.my-1(xs12 sm6)
        strong Collection Time:  
        time-changer(:time="collectionTime")
</template>
<script>
import TimeChanger from '@/components/TimeChanger'
export default {
  name:"OrderDetails",
  components:{TimeChanger},
  computed:{
    event(){
      return this.$store.state.events.find(el=>{return el.id == this.$store.state.selectedEvent})
    },
    show(){
      return this.$route.params.id != this.$store.state.selectedEvent
    },
    imageSrc(){return this.$store.state.baseImageURL +'th'+ this.event.imageURL+"?alt=media"},
    collectionTime(){
      return this.$store.state.customer.collectionTime
    }
    
  }

}
</script>


